import { defineMessages } from "react-intl";

export default defineMessages({
  header: {
    id: "baseErrorBoundary.headerText",
    defaultMessage: "Oops! Something Went Wrong",
  },
  title: {
    id: "baseErrorBoundary.title",
    defaultMessage:
      "It looks like something unexpected happened while processing your request due to a technical issue.",
  },
  subtitle: {
    id: "baseErrorBoundary.subtitle",
    defaultMessage: "Don't worry, we're working to fix it.",
  },
  reload: {
    id: "baseErrorBoundary.reload",
    defaultMessage: "Reload the page",
  },
  contactSupport: {
    id: "baseErrorBoundary.contactSupport",
    defaultMessage: "Contact support",
  },
});
